export enum EXTERNAL_URLS {
    CALCULATE_HEALTH_FEE = 'https://precio.mapfre.es/calcular-seguro-salud-global/es/fecha-inicio-seguro?origen=MAPFRES&PPPO=MINTER',
    CALL_ME_BACK = 'https://clientes.mapfre.es/boi/inicio.do?origen=salud_portalmapfre&destino=sgc_new&producto=salud',
    CALCULATE_DENTAL_FEE = 'https://precio-dental.mapfre.es/calcular-seguro-dental/dental/insuranceData'
}
